import { useEffect } from 'react'

export function useObserveBody(element: HTMLElement) {
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style'
        ) {
          if (element) {
            const root = document.querySelector(':root') as HTMLElement
            root.style.setProperty('--menu-top', element.style.marginTop)
          }
        }
      })
    })

    observer.observe(element, { attributes: true })
  }, [])
}
